export const ErrorObj={
    id:'error_page',
    lightBg:false,
    lightText:true,
    lighttextDesc: true,
    topLine: 'OOPS!!',
    headline: 'Page not found!',
    description: "The page you are looking for doesn't exist.",
    buttonLabel: 'Back to Home',
    imgStart: false,
    img: require(`../../images/error404.svg`).default,
    alt: 'error404',
    dark:true,
    primary:true,
    darkText:false,
    to:'/'
}